<template>
		<footer class="footer">
		<div class="wrapper">
			<div class="phrase">SOLUTION FOR<br>GROWTH</div>
			<div class="content">
				<div class="top">
					<div class="left">
						<div class="logo">
							<a href="./index.html">
								<div class="main">INTROVERTS</div>
								<div class="sub">Orginal Persoanl Test</div>
							</a>
						</div><!-- end .lefr -->
						<div class="address">
							<p>〒810-0001<br>
								福岡県福岡市中央区<br>天神4-4-1 4F
							</p>
							<div class="icon">
		
							</div>
						</div><!-- end .address -->
					</div><!-- end .left -->
					<div class="right">
						<nav class="main">
							<ul>
								<li><a href="https://introverts.jp/">TOP</a></li>
								<li><a href="https://introverts.jp/#/questions/">TEST</a></li>
								<li><a href="https://introverts.jp/articles/">ARTICLES</a></li>
								<li><a href="https://introverts.jp/contact/">CONTACT</a></li>
							</ul>
						</nav>
						<nav class="sub">
							<ul>
								<li><a href="https://introverts.jp/privacy-policy">プライバシーポリシー</a></li>
								<li><a href="https://introverts.jp/company">運営会社・開発者情報</a></li>
							</ul>
						</nav>
						<div class="explain">
							<p>
								内向型性格診断「INTROVERS(イントロバーツ)」は、成功科学、脳科学、心理学等のポピュラーサイエンスの多様な見地から独自に作られています。主に10代後半から20代、30代、40代、50代の夢実現や自己達成に対するアドバイスが豊富なあなたに寄り添う性格診断です。
							</p>
						</div><!-- end .explain -->
					</div><!-- end .right -->
				</div><!-- end .top -->
				<div class="bottom">
					<ul>
						<li><span>@ 内向型診断 INTROVERTS</span></li>
						<li><a href="#page-top">PAGE TOP</a></li>
					</ul>
				</div><!-- end .bottom -->
			</div><!-- end .content -->			
		</div><!-- end .wrapper -->
	</footer><!-- end .footer -->
</template>

<script>
export default {
	name: 'Footer',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

@import "../scss/_variables.scss";

.footer{
	background-color: #359799;
	background-image: linear-gradient(315deg, #359799 0%, #1a797c 74%);
	margin: 100px 0 0 0;
    .wrapper{
        .phrase {
			text-align: left;
            font-family: 'Syncopate', sans-serif;
            font-weight: 700;
             text-transform: uppercase;
             color: white;
             font-size: 90px;
             background: linear-gradient(-90deg, rgba(223,223,223,1) 0%, rgba(190,190,190,1) 100%);
             line-height: 1;
             background-clip: text;
             -webkit-text-fill-color: transparent;
             position: relative;
             text-shadow: 0 2px 2px rgba(0, 0, 0, .2),
                          0 -2px 4px rgba(255, 255, 255, .2);
            mix-blend-mode:hard-light;
            opacity: 0.3;
        }
		.content{
            padding: 200px 0 30px 0;
			.top{
				position: relative;
				z-index: 2;
				display: flex;
				align-items: center;
				justify-content: space-between;
				padding: 0 5% 0 5%;
				.left{
                    .logo{
                        a{
							text-align: left;
                            text-decoration: none;
                            color:#fff;
                            .main{
                                font-family: 'Syncopate', sans-serif;
                                font-weight: 700;
                                line-height: 1.2;
                                letter-spacing: 6px;
                                font-size:30px;
                                span{
                                    font-size:0.8em;
                                }
                            }
                            .sub{
                                font-family: 'Antonio', sans-serif;
                                line-height: 1.2;
                                font-weight: 500;
                                letter-spacing: 3px;
                                font-size:15px;
                            }
                        }
                    }
					.address{
						text-align: left;
						margin: 30px 0 0 0;
						color:#fff;
						font-size:16px;
					}
				}
				.right{
					width: 1000px;
					display: flex;
					flex-direction: column;
					nav{
						ul{
							display: flex;
							align-items: center;
							list-style-type: none;
							margin: 0 0 0 0;
							padding: 0 0 0 0;
							justify-content: flex-end;
						}
						&.main{
							ul{
								li{
									padding: 0 17px 0 17px;
									a{
										text-decoration: none;
										color:#fff;
										font-family: 'Syncopate', sans-serif;
										font-weight: 700;
										letter-spacing: 2px;
										font-size:20px;
									}
								}
							}

						}
						&.sub{
							ul{
								margin: 15px 0 0 0;
								li{
									padding: 0 17px 0 17px;
									a{
										text-decoration: none;
										color:#fff;
										font-weight: 700;
										letter-spacing: 2px;
										font-size:16px;
									}
								}
							}
						}
					}
					.explain{
						margin: 50px 0 0 0;
						padding: 0 17px 0 17px;
						p{
							color:#fff;
							letter-spacing: 1px;
							line-height: 1.8;
							font-size:12px;
						}
					}
				}
			}
			.bottom{
				ul{
					list-style-type: none;
					border-top:solid 1px #ccc;
					width: 90%;
					margin: 60px auto 0;
					padding: 0 0 0 0;
					display: flex;
					justify-content: space-between;
					li{
						font-family: 'Syncopate', sans-serif;
						color:#fff;
						font-weight: 500;
						letter-spacing: 4px;
						font-size:15px;
						padding: 10px 0 5px 0;
						a{
							text-decoration: none;
							color:#fff;
	
						}
					}
				}
			}
		}	
    }
}

/**********************************************************************************
 □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 

◆	Stylesheet: 767pxまで(スマホ)のモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/
@media screen and (max-width: 767px) {
	footer{
		margin:40px auto 0;
		font-size:15px;
	}
} /* 767px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/

/**********************************************************************************
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □   

◆	Stylesheet: さらに刻んで320pxまでのモニタで適用	◆

□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
start----------------------------------------------------------------------------*/

@media screen and (max-width: 320px) {

} /* 320px responsive-closed */

/*end ----------------------------------------------------------------------------
□ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ □ 
**********************************************************************************/

</style>
